import baseApi from "./baseApi"

export default  {
    async getBreakTypes() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/cropWorkAttendance/breakTypes");
        return result.data;
    },

    async getCropWorkAttendanceByID(id) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/cropWorkAttendance/" + id);
        return result.data;
    },

    async updateCropWorkAttendance(model) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/cropWorkAttendance", model);
        return result.data;
    }
}